export const transformScheduleResponse = (schedulesResponse) => {
   return schedulesResponse.map((schedule) => {
      const obj = {
         ...schedule,
         rows: schedule.drivers
            .slice() // clonar para no mutar el array original
            .sort((a, b) => a.rotation_position - b.rotation_position) // ordenar ascendente
            .map((driver) => ({
               id: `${schedule.id}-${driver.resource_id}`,
               driver: { ...driver, id: driver.resource_id.toString() },
            })),
      };

      // delete obj.drivers;

      return obj;
   });
};

export const transformDriversResponse = (driversResponse) => {
   return driversResponse
      .map((pilot) => ({
         id: pilot.resource.id.toString(),
         name: `${pilot.user.first_name} ${pilot.user.last_name}`,
         employee_id: pilot.resource ? pilot.resource.employee : null,
         resource_id: pilot.resource ? pilot.resource.id : null,
      }))
      .filter((pilot) => pilot.employee_id !== null && pilot.resource_id !== null);
};

export const getDriverIdsFromSchedule = (schedule) => {
   return schedule.rows.filter((row) => row.driver && row.driver.id).map((row) => Number(row.driver.id));
};

export const getStationCounts = (schedules, stationList) => {
   const countsMap = {};

   // Initialize counts for each station
   stationList.forEach((station) => {
      countsMap[station] = 0;
   });

   // Iterate through each schedule
   schedules.forEach((schedule) => {
      // Extract the station from the name
      const stationPrefix = schedule.name.split('_')[0].toLowerCase().trim();

      if (stationList.map((s) => s).includes(stationPrefix)) {
         countsMap[stationPrefix]++;
      }
   });

   // Transform the map into an array
   return stationList.map((station) => ({
      code: station,
      count: countsMap[station] || 0,
   }));
};
